module.exports = __webpack_public_path__ + "static/media/jesse-schoff-MhjxrW6gVhY-unsplash.c0db2509.jpg";